import React, { useState, useEffect } from 'react'
import { DateSelect, StateSelect, useDateFilter, useFilterReport, useSearchFilter, useSelectFilter } from '../../utils/filterutils'
import { useExpandRows, useSortSalesReport } from '../../utils/tablehooks'
import { SalesReportHeaderView, SalesReportTableView } from './SalesReportView'

const SalesReportTableContainer = ({ salesReport, options, loadReport }) => {

    const [filterable, setFilterable] = useState(false)
    const [filteredReports, setFilteredReports] = useState([])
    const [sortedReports, setSortedReports] = useState([])

    const { expandRow, getIsExpandedRow } = useExpandRows()
    const { sortSalesReport } = useSortSalesReport(salesReport, setSortedReports)
    const { filterReportBySearchInput, filterReportByDateInput, filterReportBySelectInput } = useFilterReport()
    const { dateSelect, handleDatePickerCallback, handleClearFilter } = useDateFilter()
    const [statusSelect, handleStatusSelectChange] = useSelectFilter()
    const { searchInput, handleSearchInput } = useSearchFilter()

    useEffect(() => {
        setFilteredReports([...salesReport])
        setSortedReports([...salesReport])
    }, [salesReport])

    //const takeSortedReport = () => {
    //    //Maybe this shouldn't be done in general, as there should be another option to deep clone an object!
    //    let deepCopy = JSON.parse(JSON.stringify(sortedReports))
    //    return deepCopy
    //}

    useEffect(() => {
        let filteredReport = filterReportBySearchInput([...sortedReports], searchInput)
        filteredReport = filterReportByDateInput(filteredReport, dateSelect)
        filteredReport = filterReportBySelectInput(filteredReport, statusSelect)

        setFilteredReports(filteredReport)
    }, [searchInput, dateSelect, statusSelect, sortedReports])

    /**
     * Toggles the filterable value; indicates if filter menu is opened
    */
    const setFilterbar = () => {
        setFilterable(!filterable)
    }

    const handleSortReport = (e, field) => {
        e.preventDefault()
        sortSalesReport(field)
    }

    const DateSelect1 = () => DateSelect(handleDatePickerCallback, handleClearFilter, dateSelect)

    return (
        <>
            <SalesReportHeaderView filteredReports={filteredReports} handleSearchInput={handleSearchInput} setFilterbar={setFilterbar} loadReport={loadReport} options={options} />
            <SalesReportTableView DateSelect={DateSelect} StateSelect={StateSelect} handleSortReport={handleSortReport} expandRow={expandRow} filterable={filterable} filteredReport={filteredReports} getIsExpandedRow={getIsExpandedRow} f />
        </>
    )
}

export { SalesReportTableContainer }